import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import BaseSection from '../BaseSection';
import MapModal from '../../../MapModal';
import { getLangDefinition } from '../../../../utils/helpers';
import useToggle from '../../../../hooks/useToggle';

const LocationSection = ({ city, address, lat, lng, locations }) => {
  const [isOpenModal, toggleModal] = useToggle(false);
  const {
    i18n: { language },
    t
  } = useTranslation();

  return (
    <BaseSection>
      <div className="item-location">
        <div className="item-location__address">{`${city}${t(
          'pages.residence.city'
        )}, ${address}`}</div>
        <div
          className="item-location__map"
          role="button"
          onClick={toggleModal}
          onKeyPress={toggleModal}
          tabIndex={0}
        >
          {isOpenModal && (
            <MapModal
              isOpen={isOpenModal}
              hide={toggleModal}
              id="map"
              lat={lat}
              lng={lng}
              language={getLangDefinition(language)}
            />
          )}
        </div>
        {locations &&
          locations.map((item, index) => (
            <div key={index} className="item-location__link">
              {item.fullName}
            </div>
          ))}
      </div>
    </BaseSection>
  );
};

LocationSection.propTypes = {
  city: PropTypes.string,
  address: PropTypes.string,
  locations: PropTypes.array,
  lat: PropTypes.number,
  lng: PropTypes.number
};

export default LocationSection;
